import React, { useEffect, useState } from "react";
import classes from "./ForecastMonthPage.module.css"
import { backend_routes } from "../../../common/links";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import { useAxiosGetRefreshing, useAxiosDeleteRefreshing } from "../../../hooks/useAxios";
import Forecast from "../../forecast/forecast";
import MySelect from "../../UI/select/MySelect";

const ForecastsMonthPage = function () {

    const [bodyLoaded, setBodyLoaded] = useState(false);
    const [selectedYear, setYear] = useState(0);
    const [years, setYears] = useState([]);
    const [monthFCs, setMonthFCs] = useState([]);

    const [fetchMonthsByYear, isFetchLoading] = useAxiosGetRefreshing(
        function (response) {
            setYears(response.data.data);
            setBodyLoaded(true);
        },
        function (badResponse) {
            console.log(badResponse);
        }
    );

    const [fetchMonths, isMonthsLoading] = useAxiosGetRefreshing(
        function (response) {
            for (const month of response.data.data) {
                month.kind = "month";
                month.date = month.month;
                delete month.month;
            }
            setMonthFCs(response.data.data);
        },
        function (badResponse) {
            console.log(badResponse);
        }
    );

    useEffect(() => {
        fetchMonthsByYear(backend_routes.FORECASTS_AVAILABLE_YEARS_LINK);
    }, [])

    useEffect(() => {
        if (selectedYear !== 0)
            fetchMonths(backend_routes.FORECASTS_ALL_MONTHS_BY_YEAR + selectedYear);

    }, [selectedYear])

    var deletingId;
    const handleChildElementClick = (e, id) => {
        e.stopPropagation();
        deletingId = id;
        deleteFC(backend_routes.FORECASTS_DELETE_LINK + "month/" + id);
    }
    const [deleteFC, isDeleteSending] = useAxiosDeleteRefreshing(
        async function (response) {
            if (response.data.data === 204) {
                setMonthFCs(monthFCs.filter(p => p.id !== deletingId));
            }
        },
        function (badResponse) {
            deletingId = 0;
            console.log(badResponse);
        }
    );


    const valuesToMap = function(values){
        let map = [];
        for (const year of values) {
            map.push({
                value: year,
                name: year
            })
        }
        return map;
    }

    return (
        <div className={classes.forecastsMonthPage} style={{ padding: "5px" }}>
            {isFetchLoading || !bodyLoaded
                ? <MyLoadingIcon />
                : < MySelect value={selectedYear} onChange={setYear} defaultValue={"Выберите год"} options={valuesToMap(years)}/>
            }
            <br />
            <br />
            {isMonthsLoading || isDeleteSending
                ? <MyLoadingIcon />
                : <div>
                    {monthFCs.map(item =>
                        <Forecast key={item.date} kind={"month"} forecast={item}>
                            <div key={"delete_"+item.month} className="deleteButton" onClick={(e) => handleChildElementClick(e, item.id)}>Удалить</div>
                        </Forecast>
                    )}
                </div>
            }
        </div>
    );
}
export default ForecastsMonthPage;